<template>
  <div class="flex flex-wrap">
    <div
      v-if="hasVideoIntro || hasMapPreview"
      class="w-12/12 grow mb-4 md:mb-0 flex flex-col print-hidden"
      :class="{ 'md:w-8/12': hasHighlights }"
    >
      <div
        v-if="hasVideoIntro"
        class="details-resource-and-highlights flex flex-col grow"
      >
        <LazySwiper
          class="h-full"
          v-bind="videoIntroductionsSliderOptions"
        >
          <a
            v-for="(videoIntro, idx) in trip?.videointroduction"
            :key="idx"
            class="details-resource-and-highlights-video relative block h-full"
            target="_blank"
            :href="videoIntro?.url"
            @click="trackPageView(videoIntro?.url)"
          >
            <LazyResponsiveImage
              class="top-0 left-0 size-full"
              position="absolute"
              :image="videoIntro?.cloudinary_image || trip.main_picture_cloudinary"
              :alt="trip.title"
              cover
            />
            <div class="absolute top-0 left-0 bg-light inline-flex items-center text-black rounded-2xl px-4 py-1 m-3 z-[1]">
              <fa
                class="mr-2 pr-1 h5 mb-0"
                icon="video"
              />
              <span>
                {{ videoIntro?.tourleader_name }}
              </span>
            </div>
            <div class="absolute size-full top-0 flex justify-center items-center z-[1]">
              <i-play-button
                class="play-button"
                filled
                :font-controlled="false"
                alt="play"
              />
            </div>
          </a>
        </LazySwiper>
        <div class="text-black flex flex-col px-4 py-4 md:px-4 bg-white-blue w-full">
          <h5
            class="mb-0"
            data-i18n="trip.seeOurVideo"
          >
            {{ $t('trip.seeOurVideo', trip?.videointroduction.length) }}
          </h5>
          <small
            class="font-normal"
            data-i18n="trip.videoIntroClickOnVideo"
          >{{ $t('trip.videoIntroClickOnVideo', trip?.videointroduction.length) }}</small>
        </div>
      </div>
      <div
        v-else
        class="size-full relative details-resource-and-highlights"
      >
        <LazyMarkedMapPreview
          class="size-full absolute"
          :trip="trip"
          :active-itinerary="activeItinerary"
          @open-map="$emit('openMap')"
        />
      </div>
    </div>
    <div
      v-if="hasHighlights"
      class="w-12/12 grow flex pl-0 md:pl-2"
      :class="{ 'md:w-4/12': hasVideoIntro || hasMapPreview }"
    >
      <div class="bg-blue text-white details-resource-and-highlights-highlights grow px-print-0">
        <h5 data-i18n="trip.tripHighlights">
          {{ $t('trip.tripHighlights') }}
        </h5>
        <hr class="mx-0 my-4 lg:my-4 print-hidden" />
        <div class="flex flex-col">
          <span
            v-for="(highlight, i) in trip?.highlights"
            :key="i"
            class="text-white mb-2"
            :data-translation="highlight?.highlight_translationkey"
          >{{ highlight.highlight }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const MAX_VIDEO_INTRODUCTIONS = 2

export default defineNuxtComponent({
  setup () {
    const { trackPageView } = useTracking()

    return {
      trackPageView,
    }
  },

  props: {
    trip: {
      type: Object,
      required: true,
    },

    activeItinerary: {
      type: Object,
      required: true,
    },

    hasVideoIntro: {
      type: Boolean,
      default: false,
    },

    hasMapPreview: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['openMap'],

  computed: {
    firstVideoIntro () {
      return this.trip?.videointroduction?.[0]
    },

    hasHighlights () {
      return this.trip.highlights?.length
    },

    videoIntroductions () {
      return (this.trip?.videointroduction || [])?.slice(0, MAX_VIDEO_INTRODUCTIONS)
    },

    videoIntroductionsSliderOptions () {
      return {
        slidesPerView: 1,
        navigation: false,
        loadingSkeletonAspect: false,
        loadingSkeletonHeight: '100%',
        loop: true,
        arrowsSize: 'small',
        dotsAlign: 'bottom',
        breakpoints: {
          [getTailwindBreakpointsPx().md]: {
            slidesPerView: this.videoIntroductions.length,
            pagination: false,
          },
        },
      }
    },
  },
})
</script>
